module.exports = __webpack_public_path__ + "img/showcase.14c46577.png";